
define(
	'POAItems.entrypoint'
,   [
		'POAItems.View'
	]
,   function (
		POAItemsView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			

		}
	};
});
